var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var Search = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ size: "25px" }, props),
        React.createElement("path", { d: "M14.2535209,13.5464142 L18,17.2928932 C18.1952621,17.4881554 18.1952621,17.8047379 18,18\n        C17.8047379,18.1952621 17.4881554,18.1952621 17.2928932,18 L13.5464142,14.2535209 C12.3223269,15.3144556\n        10.7252476,15.9564464 8.97822321,15.9564464 L8.97822321,15.9564464 L8.97822321,15.9564464\n        C5.12425695,15.9564464 2,12.8321895 2,8.97822321 L2,8.97822321 L2,8.97822321 C2,5.12425695\n        5.12425695,2 8.97822321,2 L8.97822321,2 L8.97822321,2 L8.97822321,2 C12.8321895,2 15.9564464,5.12425695\n        15.9564464,8.97822321 L15.9564464,8.97822321 C15.9564464,10.7252476 15.3144556,12.3223269 14.2535209,13.5464142\n        Z M9,3 L9,3 C5.6862915,3 3,5.6862915 3,9 L3,9 L3,9 C3,12.3137085 5.6862915,15 9,15 L9,15 C12.3137085,15\n        15,12.3137085 15,9 L15,9 L15,9 C15,5.6862915 12.3137085,3 9,3 L9,3 L9,3 Z" })));
};
export default Search;
